import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Outsourced} from "../Outsourced";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {OutsourcedSound} from "../sound/OutsourcedSound";
import {OutsourcedNormalResultPresentation} from "./OutsourcedNormalResultPresentation";

export class OutsourcedFreespinsResultPresentation implements FlowStatePresentation {
    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        const reels = Outsourced.reelView.reelModels;
        const isQuickStop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);

        const tl:gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.setSkipCallback();
            }
        });
        tl.add(() => {
            flowStateController.setSkipCallback(() => tl.seek("End", false))
            Outsourced.reelView.updateWays(Outsourced.model.preXwaysWays(), false);
            if (Outsourced.model.data.mode != "NORMAL_RESPIN" && Outsourced.model.data.upgradeBetCount == 0)
                Outsourced.keypadPlugin.setZeroBetSpinCounter(Outsourced.model.data.freespinsLeft);
        });

        let scatterCount = reels.filter((reel) => !reel.isSpinning && reel.getSymbols()[0].symbolName == "SC").length;
        let maxCount = reels.filter((reel) => !reel.isSpinning && reel.getSymbols()[0].symbolName == "MAX").length;
        const isFreespin = Outsourced.model.data.mode == GameMode.FREESPIN;

        if (scatterCount > 1 && scatterCount < 4)
            tl.add(Outsourced.soundPlayer.playLoopBased("anticipationReSpin"), '<');

        const lastReel = reels.filter((reel) => reel.shouldRespin).reverse()[0];

        let index = 0;
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                const currentReel = reels[reel * 4 + row];
                if (currentReel.shouldRespin) {
                    const stopTl = gsap.timeline();
                    currentReel.shouldRespin = false;

                    const stopDelay = isQuickStop
                                      ? 0
                                      : scatterCount > 1
                                      ? index > 11 ? 1 : 0.25
                                      : 0.05;

                    const stopSymbol = Outsourced.model.data.reels[reel][row];
                    if (stopSymbol == "SC")
                        scatterCount++;
                    if (stopSymbol == "MAX")
                        maxCount++;

                    stopTl.add(currentReel.stop(stopSymbol));
                    stopTl.add(Outsourced.reelView.stopConveyorBelt(reel, row, !isFreespin), '<');
                    stopTl.add(Outsourced.soundPlayer.playSoundBased(`reelLanding${index % 2 == 0 ? 1 : 2}`), '<')
                    const symbolIndex = stopSymbol == "MAX"
                                        ? reel + 1
                                        : stopSymbol == "SC"
                                        ? scatterCount
                                        : index
                    stopTl.add(OutsourcedNormalResultPresentation.landingSound(currentReel.getSymbols()[0], symbolIndex), '<');

                    if (stopSymbol == "XN" || stopSymbol == "W" || stopSymbol == "XW" ||
                        (stopSymbol == "SC" && scatterCount > 1) ||
                        (stopSymbol == "MAX" && maxCount == reel + 1 && maxCount > 1))
                        stopTl.add(currentReel.getSymbols().map((sym) => sym.getLandAnimation()))


                    if (maxCount == reel + 1 && stopSymbol == "MAX" && maxCount > 1)
                        stopTl.add(Outsourced.reelView.playLandDust(reel, row), '<');

                    // anticipation stuff
                    if (scatterCount > 1 && scatterCount < 4)
                        stopTl.add(() => {
                            Outsourced.reelView.getAllStoppedSymbols()
                                .filter((sym) => sym.symbolName == "SC")
                                .forEach((sym) => sym.startScatterAnticipation());
                        })
                    if ((stopSymbol == "SC" && scatterCount > 1) || (stopSymbol == "MAX" && maxCount == reel + 1 && maxCount > 1))
                        stopTl.add(Outsourced.backgroundElements.shake(), '<');
                    if (stopSymbol == "SC" && scatterCount == 2)
                        stopTl.add(Outsourced.soundPlayer.playLoopBased("anticipationReSpin"), '<');
                    if ((stopSymbol == "SC" && scatterCount == 4))
                        stopTl.add(Outsourced.soundPlayer.stopLoopBased("anticipationReSpin"), '<');
                    if (scatterCount > 1 && scatterCount != 4 && reel == 3)
                        stopTl.add(Outsourced.soundPlayer.playSoundBased(`anticipationLastReel${row + 1}`), '<');
                    if (scatterCount > 1 && scatterCount != 4 && reel == 2)
                        stopTl.add(Outsourced.soundPlayer.playSoundBased("anticipationReelStopColumn3"), '<');
                    if (currentReel == lastReel && scatterCount < 3 && scatterCount > 1)
                        stopTl.add(Outsourced.soundPlayer.playSoundBased("anticipationFail"), '<');
                    if (stopSymbol == "SC" || stopSymbol == "MAX")
                        stopTl.add(() => {Outsourced.reelView.darkenMultiplier(reel, row)},);

                    tl.add(stopTl, `<${stopDelay}`);
                    index++;
                }
            }
        }
        tl.add(Outsourced.soundPlayer.stopLoopBased("anticipationReSpin"));
        tl.add(() => {
            Outsourced.reelView.getAllStoppedSymbols()
                .filter((sym) => sym.symbolName == "SC")
                .forEach((sym) => sym.stopScatterAnticipation());
        }, '<')

        if (scatterCount > 1 && scatterCount < 3)
            tl.add(Outsourced.soundPlayer.playSoundBased("anticipationEndReSpin"));
        tl.add(Outsourced.soundPlayer.stopLoopBased("respinReelSpinLoop"));

        tl.add(() => {
            Outsourced.reelView.extractSymbols();
        });

        tl.add(() => {
            flowStateController.finish()
        });
    }
}